import service from "@/store/services/stock-movements-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  stockMovement: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, stockMovement) => {
    state.stockMovement = stockMovement;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((stockMovement) => {
      commit("SET_RESOURCE", stockMovement);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((stockMovement) => {
      commit("SET_RESOURCE", stockMovement);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((stockMovement) => {
      commit("SET_RESOURCE", stockMovement);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  validate({ commit, dispatch }, params) {
    return service.validate(params, this.$axios).then((stockMovement) => {
      commit("SET_RESOURCE", stockMovement);
    });
  },

  cancel({ commit, dispatch }, params) {
    return service.cancel(params, this.$axios).then((stockMovement) => {
      commit("SET_RESOURCE", stockMovement);
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  stockMovement: (state) => state.stockMovement,
  url: (state) => state.url,
};

const stockMovements = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default stockMovements;
